import { ErrorType, JapaneseServiceError } from './types';
import { error as logError } from './logger';

/**
 * 创建网络错误
 */
export const createNetworkError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.NETWORK, details);
};

/**
 * 创建超时错误
 */
export const createTimeoutError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.TIMEOUT, details);
};

/**
 * 创建解析错误
 */
export const createParseError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.PARSE, details);
};

/**
 * 创建分词错误
 */
export const createTokenizeError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.TOKENIZE, details);
};

/**
 * 创建翻译错误
 */
export const createTranslateError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.TRANSLATE, details);
};

/**
 * 创建转换错误
 */
export const createConvertError = (message: string, details?: any): JapaneseServiceError => {
  return new JapaneseServiceError(message, ErrorType.CONVERT, details);
};

/**
 * 处理错误并返回默认值
 * @param error 错误对象
 * @param defaultValue 默认返回值
 * @param context 错误上下文
 */
export function handleError<T>(error: any, defaultValue: T, context: string): T {
  if (error instanceof JapaneseServiceError) {
    logError(`${context}: ${error.message}`, error);
  } else {
    logError(`${context}: ${error?.message || '未知错误'}`, error);
  }
  return defaultValue;
}

/**
 * 包装异步函数，统一处理错误
 * @param fn 要包装的异步函数
 * @param defaultValue 出错时的默认返回值
 * @param context 错误上下文
 */
export function withErrorHandling<T, Args extends any[]>(
  fn: (...args: Args) => Promise<T>,
  defaultValue: T,
  context: string
): (...args: Args) => Promise<T> {
  return async (...args: Args): Promise<T> => {
    try {
      return await fn(...args);
    } catch (error) {
      return handleError(error, defaultValue, context);
    }
  };
}